import { render, staticRenderFns } from "./Termscondition.vue?vue&type=template&id=7e422cf4&scoped=true"
import script from "./Termscondition.vue?vue&type=script&lang=js"
export * from "./Termscondition.vue?vue&type=script&lang=js"
import style0 from "./Termscondition.vue?vue&type=style&index=0&id=7e422cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e422cf4",
  null
  
)

export default component.exports